import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import * as _ from 'lodash';
import {ApiResponse, AuthService, BaseService} from '@hassel-it/angular-common';
import {HttpClient, HttpParams} from '@angular/common/http';
import {PriceRobotReport, PriceRobotReportInterface} from "./price-robot-report";

@Injectable()
export class PriceRobotReportsService extends BaseService {

    constructor(public http: HttpClient, public authService: AuthService) {
        super(http, authService);
    }

    buildParameters(options: ReportsOptions): HttpParams {
        return new HttpParams();
    }

    getReports(page: number = 1, options: ReportsOptions): Promise<any> {
        this.reloadHeaders();
        let params = this.buildParameters(options);
        params = params.set('page', <any>page);

        return this.http.get(environment.apiBase + '/api/tenfour-crawler/reports', {
            params: params,
            headers: this.httpHeaders
        }).toPromise().then((response: any) => {
            const results = _.chain(response.data).map((json: PriceRobotReportInterface): PriceRobotReport => {
                return PriceRobotReport.fromJSON(json)
            }).value();
            return new ApiResponse(results, response.pagination.count as number);
        }).catch(PriceRobotReportsService.handleError);
    }


    createPriceRobotReport(priceRobotReport: PriceRobotReport): Promise<PriceRobotReport> {
        this.reloadHeaders();

        return this.http.post(environment.apiBase + '/api/tenfour-crawler/reports', priceRobotReport, {
            headers: this.httpHeaders
        }).toPromise().then((response: any) => {
            return response.data as PriceRobotReport;
        }).catch(PriceRobotReportsService.handleError);
    }

    updatePriceRobotReport(priceRobotReport: PriceRobotReport): Promise<PriceRobotReport> {
        this.reloadHeaders();

        return this.http.patch(environment.apiBase + '/api/tenfour-crawler/reports/' + priceRobotReport.id, priceRobotReport, {
            headers: this.httpHeaders
        }).toPromise().then((response: any) => {
            return response.data as PriceRobotReport;
        }).catch(PriceRobotReportsService.handleError);
    }

    deletePriceRobotReport(priceRobotReport: PriceRobotReport): Promise<boolean> {
        this.reloadHeaders();

        return this.http.delete(environment.apiBase + '/api/tenfour-crawler/reports/' + priceRobotReport.id, {
            headers: this.httpHeaders
        }).toPromise().then((response) => {
            return true
        }).catch(PriceRobotReportsService.handleError);
    }
}

export interface ReportsOptions {
}
